import React from 'react';
import {
  EXTERNAL_LINK_PROPS,
  landingSiteUrl,
  trackLandingSiteClick,
} from '../../utils/landingSite';
import { analyticsConfigured } from '../../config/posthog';
import CookieSettingsLink from '../common/CookieSettingsLink';

interface PoweredByBasiQRProps {
  /** The public surface this link sits on — becomes the utm_source. */
  source: string;
  className?: string;
}

/**
 * The "Powered by BasiQR" footer credit on public pages, with the "Cookie
 * settings" link that changes the analytics choice there.
 *
 * Deliberately an external anchor rather than a router link: these pages are
 * reached by scanning a QR code with a phone, and an in-SPA `/` dead-ends on
 * the desktop-only gate (#260).
 */
export const PoweredByBasiQR: React.FC<PoweredByBasiQRProps> = ({ source, className }) => (
  <p className={className ?? 'text-white/30 text-sm'}>
    Powered by{' '}
    <a
      href={landingSiteUrl(source)}
      {...EXTERNAL_LINK_PROPS}
      onClick={() => trackLandingSiteClick(source)}
      className="text-[#f4a261] hover:text-[#f7b98a] transition-colors"
    >
      BasiQR
    </a>
    {analyticsConfigured() && (
      <>
        <span aria-hidden="true"> · </span>
        <CookieSettingsLink className="hover:text-white/60 transition-colors underline-offset-2 hover:underline" />
      </>
    )}
  </p>
);

export default PoweredByBasiQR;
